<template>
  <div class="profile">
    <div
      class="banner d-none d-lg-block w-100"
      :style="{
        backgroundImage: `url(${
          profile && profile.cropped_banner
            ? profile.cropped_banner
            : require('../assets/profile_bg.png')
        })`
      }"
    ></div>
    <div class="profile-container d-flex flex-column align-items-center">
      <author :author="profile" class="mb-10" v-if="profile" />

      <div class="links mb-10 d-flex">
        <a
          style="opacity: 0.1;"
          v-if="
            !profile.website &&
              !profile.instagram &&
              !profile.facebook &&
              !profile.twitter &&
              !profile.pinterest &&
              !profile.tumblr &&
              !profile.youtube &&
              !profile.vimeo
          "
        >
          <img src="../assets/home_black.png" />
        </a>
        <a :href="profile.website" target="_blank" v-if="profile.website">
          <img src="../assets/home_black.png" />
        </a>
        <a
          :href="`https://www.instagram.com/${profile.instagram}/`"
          target="_blank"
          v-if="profile.instagram"
        >
          <img src="../assets/instagram_black.png" />
        </a>
        <a
          :href="`https://www.facebook.com/${profile.facebook}`"
          target="_blank"
          v-if="profile.facebook"
        >
          <img src="../assets/facebook_black.png" />
        </a>
        <a
          :href="`https://twitter.com/${profile.twitter}`"
          target="_blank"
          v-if="profile.twitter"
        >
          <img src="../assets/twitter_black.png" />
        </a>
        <a
          :href="`https://www.pinterest.co.kr/${profile.pinterest}/`"
          target="_blank"
          v-if="profile.pinterest"
        >
          <img src="../assets/pinterest_black.png" />
        </a>
        <a
          :href="`https://${profile.tumblr}.tumblr.com/`"
          target="_blank"
          v-if="profile.tumblr"
        >
          <img src="../assets/tumblr_black.png" />
        </a>
        <a
          :href="`https://www.youtube.com/${profile.youtube}`"
          target="_blank"
          v-if="profile.youtube"
        >
          <img src="../assets/youtube_black.png" />
        </a>
        <a
          :href="`https://vimeo.com/${profile.vimeo}`"
          target="_blank"
          v-if="profile.vimeo"
        >
          <img src="../assets/vimeo_black.png" />
        </a>
      </div>
      <div class="cards w-100 mb-10" v-show="!collapsed">
        <b-card>
          <b-btn variant="link" @click="open">
            <font-awesome-icon
              :icon="['fa', 'user-edit']"
              v-if="profile.id === user.id"
            />
          </b-btn>
          <h4 class="card-title">BIOGRAPHY</h4>
          <pre class="card-text">{{ profile.biography }}</pre>
        </b-card>
        <b-card title="ABOUT">
          <pre class="card-text">{{ profile.about }}</pre>
        </b-card>
        <b-card title="CONTACT">
          <p class="card-text">
            <font-awesome-icon :icon="['fa', 'envelope']" class="mr-1" />
            <a :href="`mailto:${profile.email}`">
              {{ profile.email }}
            </a>
          </p>
        </b-card>
      </div>
      <b-btn
        variant="red"
        :disabled="!profile.id"
        @click="collapsed = !collapsed"
      >
        Profile
        <font-awesome-icon
          :icon="['fa', 'angle-up']"
          :class="collapsed ? 'fa-rotate-180' : null"
        />
      </b-btn>
    </div>

    <cropper
      size="lg"
      title="Profile Image"
      :image="draft.raw_avatar || draft.avatar"
      :aspectRatio="1"
      @crop="onAvatarCropped"
      @cancel="onAvatarCancelled"
      class="avatar"
      ref="avatarCropper"
      v-if="draft"
    ></cropper>
    <cropper
      size="lg"
      title="Banner Image"
      :image="draft.raw_banner || draft.banner"
      :aspectRatio="2000 / 500"
      @crop="onBannerCropped"
      @cancel="onBannerCancelled"
      ref="bannerCropper"
      v-if="draft"
    ></cropper>
    <b-modal
      size="container"
      header-class="d-lg-none"
      body-class="p-5"
      class="profile"
      @hide="hide"
      ref="modal"
      v-if="draft"
    >
      <b-form @submit.prevent="save" ref="form">
        <input type="submit" class="d-none" ref="submit" />
        <b-row>
          <b-col
            cols="12"
            lg="4"
            class="d-flex justify-content-center align-items-center"
          >
            <dropzone
              class="avatar d-flex flex-column align-items-center"
              @click="clickAvatar"
              v-model="draft.avatar"
            >
              <img
                :src="draft.cropped_avatar"
                class="img-fluid rounded-circle"
                v-if="draft.cropped_avatar"
              />
              <img src="../assets/avatar.png" class="img-fluid" v-else />
              프로필 사진
              <b-btn @click.stop="deleteAvatar" v-if="this.draft.cropped_avatar"
                >Delete</b-btn
              >
            </dropzone>
          </b-col>
          <b-col cols="12" lg="4">
            <b-row>
              <b-col cols="12" lg="12">
                <b-form-group label="사용자명">
                  <b-form-input
                    type="text"
                    title="영어만 사용이 가능합니다."
                    pattern="[\w.+-]+$"
                    size="sm"
                    v-model="draft.username"
                    :state="feedback.username ? !feedback.username : null"
                  />
                  <b-form-invalid-feedback
                    :key="index"
                    v-for="(f, index) in feedback.username"
                    v-if="feedback.username"
                  >
                    {{ f }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="12">
                <b-form-group label="이름">
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="draft.name"
                    :state="feedback.name ? !feedback.name : null"
                    required
                  />
                  <b-form-invalid-feedback
                    :key="index"
                    v-for="(f, index) in feedback.name"
                    v-if="feedback.name"
                  >
                    {{ f }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="12">
                <b-form-group label="메일">
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="draft.email"
                    :state="feedback.email ? !feedback.email : null"
                    required
                  />
                  <b-form-invalid-feedback
                    :key="index"
                    v-for="(f, index) in feedback.email"
                    v-if="feedback.email"
                  >
                    {{ f }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="12">
                <b-form-group label="연락처">
                  <b-form-input
                    type="text"
                    size="sm"
                    v-model="draft.phone"
                    :state="feedback.phone ? !feedback.phone : null"
                    required
                  />
                  <b-form-invalid-feedback
                    :key="index"
                    v-for="(f, index) in feedback.phone"
                    v-if="feedback.phone"
                  >
                    {{ f }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="12">
                <b-form-group
                  label="주 분야"
                  @click.native="$refs.category.$el.focus"
                >
                  <multi-select
                    title="2개 선택 가능"
                    v-model="draft.categories"
                    source="category"
                    :options="categories"
                    :max="2"
                    @submit="save"
                    @click.native.stop
                    ref="category"
                  >
                    <span slot="checker" slot-scope="{ selectionIndex }">
                      <template v-if="selectionIndex">✓</template>
                      <template v-else>★</template>
                    </span>
                  </multi-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="4">
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img src="../assets/home_black.png" class="img-fluid mr-1" />
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.website" />
            </b-input-group>
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img
                  src="../assets/instagram_black.png"
                  class="img-fluid mr-1"
                />
                www.instagram.com/
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.instagram" />
            </b-input-group>
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img
                  src="../assets/facebook_black.png"
                  class="img-fluid mr-1"
                />
                www.facebook.com/
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.facebook" />
            </b-input-group>
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img src="../assets/twitter_black.png" class="img-fluid mr-1" />
                www.twitter.com/
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.twitter" />
            </b-input-group>
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img
                  src="../assets/pinterest_black.png"
                  class="img-fluid mr-1"
                />
                www.pinterest.com/
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.pinterest" />
            </b-input-group>
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img src="../assets/tumblr_black.png" class="img-fluid mr-1" />
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.tumblr" />
              <b-input-group-append class="d-flex align-items-center">
                .tumblr.com
              </b-input-group-append>
            </b-input-group>
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img src="../assets/youtube_black.png" class="img-fluid mr-1" />
                www.youtube.com/
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.youtube" />
            </b-input-group>
            <b-input-group class="mb-1">
              <b-input-group-prepend class="d-flex align-items-center">
                <img src="../assets/vimeo_black.png" class="img-fluid mr-1" />
                www.vimeo.com/
              </b-input-group-prepend>
              <b-form-input size="sm" v-model="draft.vimeo" />
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="4" class="box">
            <b-form-textarea
              rows="10"
              max-rows="10"
              v-model="draft.biography"
              placeholder="경력 / Biography"
            />
          </b-col>
          <b-col cols="12" lg="4" class="box">
            <b-form-textarea
              rows="10"
              max-rows="10"
              v-model="draft.about"
              placeholder="소개 / About"
            />
          </b-col>
          <b-col cols="12" lg="4" class="box">
            <div class="collection">
              <b-form-group label="컬렉션 리스트" label-cols="4">
                <b-form-radio
                  class="col-6"
                  v-model="draft.public_collection"
                  :value="true"
                  >공개</b-form-radio
                >
                <b-form-radio
                  class="col-6"
                  v-model="draft.public_collection"
                  :value="false"
                  >비공개</b-form-radio
                >
              </b-form-group>
            </div>
            <div class="grid">
              <b-form-group label="그리드 정렬" label-cols="4">
                <b-form-radio
                  class="col-6"
                  v-model="draft.fixed_layout"
                  :value="true"
                >
                  일자형
                  <img src="../assets/fixed.png" class="img-fluid" />
                </b-form-radio>
                <b-form-radio
                  class="col-6"
                  v-model="draft.fixed_layout"
                  :value="false"
                >
                  비율맞춤형
                  <img src="../assets/fluid.png" class="img-fluid" />
                </b-form-radio>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="box">
            <dropzone @click="clickBanner" v-model="draft.banner">
              <img
                :src="draft.cropped_banner"
                class="img-fluid w-100"
                v-if="draft.cropped_banner"
              />
              <div
                class="d-flex justify-content-center align-items-center"
                v-else
              >
                배너 이미지 업로드<br />
                (2000 X 500)
                <div class="banner-padding" />
              </div>
            </dropzone>
          </b-col>
          <b-col cols="12" v-if="this.draft.cropped_banner">
            <b-btn @click="deleteBanner" class="float-right">Delete</b-btn>
          </b-col>
        </b-row>
      </b-form>
      <template slot="modal-footer" class="w-100">
        <b-btn variant="secondary" @click="close">
          닫기
        </b-btn>
        <b-btn variant="primary" @click="save">
          저장
        </b-btn>
      </template>
    </b-modal>
    <artworks
      v-model="artworks"
      :fixed-layout="profile ? profile.fixed_layout : null"
    >
      <div
        class="text-danger text-right small"
        v-if="profile.id === user.id && !user.is_premium"
      >
        멤버십 미가입 아티스트는 업로드하는 모든 프로젝트가 타인에게 보여지지
        않습니다.<br />
        Any artist who does not have a membership will not be able to see all
        the projects you upload.
      </div>
      <ul class="type">
        <li>
          <b-link
            :class="{ active: !$route.query.type }"
            :to="{
              name: 'profile',
              params: {
                slug: $route.params.slug
              }
            }"
            exact
            @click="() => loadArtworks()"
            v-if="$route.params.slug"
          >
            Projects
          </b-link>
        </li>
        <li>
          <b-link
            :class="{ active: $route.query.type === 'collection' }"
            :to="{
              name: 'profile',
              params: {
                slug: $route.params.slug
              },
              query: { type: 'collection' }
            }"
            exact
            @click="() => loadArtworks()"
            v-if="$route.params.slug"
          >
            Collection
          </b-link>
        </li>
        <li>
          <b-link
            :class="{ active: $route.query.type === 'application' }"
            :to="{
              name: 'profile',
              params: {
                slug: $route.params.slug
              },
              query: { type: 'application' }
            }"
            exact
            @click="() => loadArtworks()"
            v-if="$route.params.slug"
          >
            My submission
          </b-link>
        </li>
      </ul>
    </artworks>
    <slot />
  </div>
</template>

<script>
import Vue from "vue";
import Author from "../components/Author";
import Dropzone from "../components/Dropzone";
import MultiSelect from "../components/MultiSelect";
import Cropper from "../components/Cropper";
import { Artwork, User } from "../models";

export default Vue.component("profile", {
  components: {
    Author,
    Dropzone,
    MultiSelect,
    Cropper
  },
  data() {
    return {
      user: window.user,
      categories: window.categories,
      profile: {},
      editing: null,
      draft: null,
      collapsed: true,
      artworks: null,
      feedback: {}
    };
  },
  watch: {
    async "$route.params.slug"() {
      if (!this.$route.params.slug) {
        return;
      }
      await this.load();
    },
    "profile.id"() {
      this.artworks = null;
      this.loadArtworks();
    },
    draft() {
      if (!this.draft) {
        return;
      }

      this.$nextTick(() => {
        this.$refs.modal.show();
      });
    },
    "draft.avatar"() {
      if (this.draft && this.draft.avatar && !this.draft.cropped_avatar) {
        this.$refs.avatarCropper.makeCropper();
      }
    },
    "draft.banner"() {
      if (this.draft && this.draft.banner && !this.draft.cropped_banner) {
        this.$refs.bannerCropper.makeCropper();
      }
    }
  },
  async activated() {
    await this.load();
  },
  methods: {
    async load() {
      const slug = this.$route.params.slug.toLowerCase().replace(/\./gi, "");
      if (slug === this.profile.slug) {
        return;
      }

      this.profile = {};
      this.artworks = null;
      this.collapsed = true;

      try {
        const profiles = await new User().get({
          slug
        });
        if (!profiles.count) {
          return this.$router.push({ name: "home" });
        }

        this.profile = profiles.results[0];
      } catch (e) {
        return this.$router.push({ name: "home" });
      }
    },
    async loadArtworks(id) {
      if (!id) {
        id = this.profile.id;
      }

      if (id) {
        this.artworks = await new Artwork().byUser(id, {
          type: this.$route.query.type
        });
      }
    },
    open() {
      if (this.editing) {
        this.draft = new User(this.editing);
      } else {
        this.draft = new User(this.profile);
      }
    },
    close() {
      if (!this.$refs.modal) {
        return;
      }

      this.$refs.modal.hide();
    },
    async save() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.submit.click();
        return;
      }

      try {
        this.profile = await this.draft.save();
        this.user.cropped_avatar = this.profile.cropped_avatar;
        this.draft = this.editing = null;
        this.feedback = {};
        this.close();
      } catch ({ response }) {
        if (response && response.status === 400) {
          this.feedback = response.data;
        }
      }
    },
    clickAvatar(event) {
      if (!this.draft.avatar) {
        return;
      }

      event.stopPropagation();
      this.$refs.avatarCropper.makeCropper();
    },
    deleteAvatar() {
      this.draft.avatar = this.draft.cropped_avatar = this.draft.raw_avatar = null;
    },
    onAvatarCropped(blob) {
      this.draft.cropped_avatar = blob;
      this.editing = this.draft;
      this.draft = null;
      this.open();
    },
    onAvatarCancelled() {
      this.editing = this.draft;
      this.draft = null;
      this.open();
    },
    clickBanner(event) {
      if (!this.draft.banner) {
        return;
      }

      event.stopPropagation();
      this.$refs.bannerCropper.makeCropper();
    },
    deleteBanner() {
      this.draft.banner = this.draft.cropped_banner = this.draft.raw_banner = null;
    },
    onBannerCropped(blob) {
      this.draft.cropped_banner = blob;
      this.editing = this.draft;
      this.draft = null;
      this.open();
    },
    onBannerCancelled() {
      this.draft.banner = this.draft.cropped_banner = this.draft.raw_banner = null;
    }
  }
});
</script>

<style lang="scss" scoped>
$grid-gutter-width: 10px;
@import "~bootstrap/scss/bootstrap-grid.scss";

.profile {
  @include media-breakpoint-up(lg) {
    margin-top: 160px;
  }
}

.banner {
  background-size: cover;
  background-position: center;
  z-index: 1019;
  position: fixed;
  top: 0;
  height: 248px;
}

.profile-container {
  padding: 52px 0 17px;
}

.artwork-container {
  @media (min-width: 1340px) {
    max-width: 1340px !important;
  }
}

.mb-10 {
  margin-bottom: 10px;
}

.links {
  a img {
    width: 22px;
    margin: 0 2px;
  }
}

.cards {
  max-width: 340px;

  .card {
    border-radius: 0;
    border-top: solid 1px;

    &:last-child {
      border-bottom: solid 1px;
    }

    .btn-link {
      float: right;
      padding: 0;
      color: black !important;
    }

    .card-body {
      padding: 10px 0;

      .card-title {
        font-weight: bold;
        font-size: 13px;
      }

      pre {
        white-space: pre-wrap;
      }
    }
  }
}

/deep/ .modal {
  .modal-header,
  .modal-footer {
    justify-content: center;
    border: 0;
  }

  .row {
    margin-left: -2.5px;
    margin-right: -2.5px;

    .col-lg-4,
    .col-12 {
      padding: 2.5px;
    }
  }
}

/deep/ .form-row {
  align-items: center;
}

.avatar /deep/ .cropper-view-box {
  border-radius: 50%;
}

.input-group-prepend {
  img {
    width: 21px;
  }
}

.box {
  margin-bottom: 5px;

  > * {
    background-color: #eaeaea;
    border: solid 1px #a6a6a6;
  }
}

textarea {
  height: 100%;
  resize: none;
  border-radius: 0;
}

.avatar {
  img {
    width: 150px;
  }
}

.grid,
.collection {
  padding: 15px;
  margin-bottom: 5px;

  fieldset:last-child {
    margin: 0;
  }
}

.banner-padding {
  padding-top: 25%;
}

div[role="radiogroup"] {
  display: flex;

  /deep/ .custom-control-label {
    display: flex;
    align-items: center;
    margin-bottom: 1px;

    &:before {
      background-color: white;
    }
  }
}

.grid {
  height: calc(100% - 85px);

  .custom-radio {
    margin: 0;
  }
}

.type {
  overflow: auto;
  padding: 0;

  li {
    float: left;
    margin-left: 30px;
  }

  a {
    color: #acacac;

    &.active {
      color: black;
    }
  }
}
</style>
